export const PASSWORD_RULES = [
  { label: 'En az 8 karakter', test: (p) => p.length >= 8 },
  { label: 'En az bir harf', test: (p) => /[A-Za-zÇĞİÖŞÜçğıöşü]/.test(p) },
  { label: 'En az bir rakam', test: (p) => /\d/.test(p) },
];

export const PASSWORD_RULE_MSG = 'Şifre en az 8 karakter olmalı, en az bir harf ve bir rakam içermelidir';

export const isStrongPassword = (p = '') => PASSWORD_RULES.every(r => r.test(p));
